import React from "react";
import { FormSectionElements, FormSections, ProgramContainer } from "src/entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
  field: FormSectionElements;
  isEng: boolean;
  callbackElement;
  callbackStepIndex?: (index: number, currentIndex?: number) => void;
}

interface State {
  

}


export class TableMenuComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

   let field = this.props.field;
   FormValidationUtils.runJavascript(field);
  }

  // CMA questionaire checking category status
  checkCategoryStatus = (stepIndex: number) => {
    const programContainer = getRootComponent(this.props.field);
    const categorySection = programContainer.ListOfFormSections[stepIndex];
    const questionsList = categorySection.ListOfFormSubSections[0].ListOfFormSectionElements.filter((element) => element.Datatype == "RadioButton");
    const completedQuestions = questionsList.filter((ele) => ele.Value);
    if (completedQuestions.length == 0) {
      return "Not started yet";
    } else if (completedQuestions.length == questionsList.length) {
      return "Completed";
    }
    return "In progress";
  }
  
  generateContent = () => {
    let resultContent = [];
    
    if (this.props.field.CMADashboard) {
      resultContent.push(
        <div className="ontario-summary-list">
        <div className="ontario-summary-list-heading__container">
          {this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle}
        </div>
        <dl className="ontario-summary-list__container">
          {this.generateRowContent(this.props.field.TableMenuRows)}
        </dl>
      </div>
      );
    } else {

      resultContent.push(
        <div className="ontario-summary-list">
          <div className="ontario-summary-list-heading__container">
            <h3 className="ontario-summary-list__heading">{this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle}</h3>
          </div>
          <dl className="ontario-summary-list__container">
            {this.generateRowContent(this.props.field.TableMenuRows)}
          </dl>
        </div>
      );
    }

    return(resultContent);
  }

  generateRowContent = (rows) => {
    let resultContent = [];
    const section = this.props.field.parent.parent as FormSections;
    const programContainer=section.parent as ProgramContainer;
    const currentIndex = programContainer.ListOfFormSections.findIndex(p=>p.Id==section.Id);
    for (let rowData of rows) {
      let status = "Completed";
      if (rowData.stepIndex) {status = this.checkCategoryStatus(rowData.stepIndex)}
      resultContent.push(
        <div className="ontario-summary-list__row">
          <dt className="ontario-summary-list__key">{this.props.isEng ? rowData.value : rowData.valueFRA}</dt>
          <dd className="ontario-summary-list__value">{status}</dd>
          <dd className="ontario-summary-list-button__container">
            <a className="ontario-summary-list-change__button" onClick={() => this.props.callbackStepIndex(rowData.stepIndex, currentIndex)}>Change</a>
          </dd>
        </div>
      );
    }
    return (resultContent);
  };

  render() {
    return (
      this.generateContent()
    )
  }
}